module.exports = __webpack_public_path__ + "static/media/bookmark.18d140c5.svg";